import Vue from 'vue'

require('es6-promise').polyfill()
import 'vue-ydui/dist/ydui.rem.css'
import 'vue-ydui/dist/ydui.base.css'
import './common/stylus/index.styl'
import App from './App.vue'
import router from './router'
import moment from 'moment'
import './filters'

Vue.prototype.moment = moment

import {CellGroup, CellItem} from 'vue-ydui/dist/lib.rem/cell';
Vue.component(CellGroup.name, CellGroup);
Vue.component(CellItem.name, CellItem);

import {Layout} from 'vue-ydui/dist/lib.rem/layout';
Vue.component(Layout.name, Layout);

import {Popup} from 'vue-ydui/dist/lib.rem/popup';
Vue.component(Popup.name, Popup);

import {Input} from 'vue-ydui/dist/lib.rem/input';
Vue.component(Input.name, Input);

import {SendCode} from 'vue-ydui/dist/lib.rem/sendcode';
Vue.component(SendCode.name, SendCode);

import {Spinner} from 'vue-ydui/dist/lib.rem/spinner';
Vue.component(Spinner.name, Spinner);

import {TextArea} from 'vue-ydui/dist/lib.rem/textarea';
Vue.component(TextArea.name, TextArea);

import {Tab, TabPanel} from 'vue-ydui/dist/lib.rem/tab';
Vue.component(Tab.name, Tab);
Vue.component(TabPanel.name, TabPanel);

import {Button, ButtonGroup} from 'vue-ydui/dist/lib.rem/button';
Vue.component(Button.name, Button);
Vue.component(ButtonGroup.name, ButtonGroup);

import { Confirm, Alert, Toast, Notify, Loading } from 'vue-ydui/dist/lib.rem/dialog';
Vue.prototype.$dialog = {
    confirm: Confirm,
    alert: Alert,
    toast: Toast,
    notify: Notify,
    loading: Loading,
};

import {ListTheme, ListItem, ListOther} from 'vue-ydui/dist/lib.rem/list';
Vue.component(ListTheme.name, ListTheme);
Vue.component(ListItem.name, ListItem);
Vue.component(ListOther.name, ListOther);

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
    preLoad: 1.3,
    // error: 'static/loading.gif',
    // loading: 'static/loading.gif',
    attempt: 1,
    try: 2
})
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = `音悦艺道-${to.meta.title}`
    }
    next()
  })

Vue.prototype.downloadApp = function () {
    var ua = window.navigator.userAgent;
    var isIos = /iPhone|iPad/.test(ua);
    if (isIos) {
        // appStore地址
        window.location.href = 'https://itunes.apple.com/cn/app/音悦艺道/id1319755271?l=zh&ls=1&mt=8'
    } else {
        // 应用宝地址
        window.location.href = 'http://sj.qq.com/myapp/detail.htm?apkName=com.sudaotech.yidao'
    }
}

import {store} from './store/index.js'

new Vue({
    el: '#app',
    router,
    ...App,
    store
})



// WEBPACK FOOTER //
// ./src/main.js